// @ts-nocheck


import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../components/ui';

import { InputNumber } from '../../components/inputs';

import { gpmVehicleTypes, orderStatuses } from '../../lib/enum';
import { formatDateTimeToISOString } from '../../lib/helpers';






import {
  Card,
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem } from
'./../../components';
import { OrgUnitSelect, Selects } from './../../components/';
import { Option, Select } from './../../components/ant/Select';

const { Field } = Card;
const {
  OrderTypeDispatcherSelect,
  VehicleTypeSelect,
  OrderObjectiveSelect,
  YesNoSelect,
  VehicleSelect,
  VehicleOwnerTypeSelect
} = Selects;

const StyledContent = styled.div.withConfig({ displayName: "Filter__StyledContent", componentId: "sc-p4yadv-0" })(["padding:16px;"]);





























const getStatuses = (mode) => {
  switch (mode) {
    case 'income':
      return ['created', 'approvingByMainEngineer', 'approvedByMainEngineer'];
    case 'archive':
      return ['approved', 'cancelled'];
    default:
      return [
      'created',
      'approvingByMainEngineer',
      'approvedByMainEngineer',
      'approved',
      'cancelled'];

  }
};

export const OrderFilter = ({
  filter,
  applyFilter,
  cleanFilter,
  mode,
  handlingOrder
}) =>
<StyledContent>
    <FilterContainer>
      <Filter
      initialValues={filter}
      applyFilter={applyFilter}
      cleanFilter={cleanFilter}
      additionalFilter={true}>

        {({
        values,
        showAdditional,
        changeValue,
        applyFilter,
        handleAdditional,
        cleanFilter
      }) =>
      <>
            {handlingOrder &&
        <FilterItem>
                <Field mBottomNone>
                  <OrderTypeDispatcherSelect
              size="small"
              value={values.getBranch ? 'all' : 'self'}
              onChange={(value) =>
              changeValue('getBranch', value === 'all')
              } />

                </Field>
              </FilterItem>
        }
            <FilterItem>
              <Field mBottomNone>
                <InputNumber
              style={{ width: '100%' }}
              size="small"
              placeholder="Номер заявки"
              onChange={(value) => changeValue('id', value)}
              value={values.id}
              min={1} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              size="small"
              startDate={
              values.startDate ? moment.utc(values.startDate) : null
              }
              endDate={values.endDate ? moment.utc(values.endDate) : null}
              onChange={changeValue} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
              size="small"
              placeholder="Все службы"
              onChange={(value) => changeValue('orgUnitId', value)}
              value={values.orgUnitId} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <Select
              size="small"
              placeholder="Все статусы"
              value={values.status}
              onChange={(value) => changeValue('status', value)}>

                  {getStatuses(mode).map((key) =>
              <Option key={key} value={key}>
                      {orderStatuses[key]}
                    </Option>
              )}
                </Select>
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleSelect
              placeholder="Все ТС"
              size="small"
              value={values['vehicle.id']}
              onChange={(id) => changeValue('vehicle.id', id)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleOwnerTypeSelect
              placeholder="Собственные и наемные ТС"
              size="small"
              value={values['vehicle.ownerType']}
              onChange={(id) =>
              changeValue('vehicle.ownerType', id)
              } />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleTypeSelect
              size="small"
              placeholder="Все типы ТС"
              value={values.vehicleType}
              selectableGroup
              onlyTypes={values.isGpm && gpmVehicleTypes}
              onChange={(value) => changeValue('vehicleType', value)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrderObjectiveSelect
              size="small"
              placeholder="Цель поездки"
              value={values.objective}
              onChange={(value) => changeValue('objective', value)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <YesNoSelect
              placeholder="Укажите командировку"
              optionText="Командировка"
              size="small"
              reset
              fullWidth
              value={values.isBusinessTrip}
              onChange={(value) =>
              changeValue('isBusinessTrip', value)
              } />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <YesNoSelect
              size="small"
              placeholder="Укажите ГПМ"
              optionText="ГПМ"
              reset
              fullWidth
              value={values.isGpm}
              onChange={(value) => changeValue('isGpm', value)} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter}
          handleAdditional={handleAdditional}
          showAdditional={showAdditional} />

          </>
      }
      </Filter>
    </FilterContainer>
  </StyledContent>;


export default OrderFilter;